const commonProperties = {
    FontSizeBase: '1rem',
    FontSizeLg: '1.2rem',
    FontSizeSm: '.8rem',
    FontWeightBase: 300,
    FontWeightSemibold: 400,
    FontWeightBold: 500,
    GreyedColor: '#808080',
    WarningColor: '#f5222d',
    SuccessColor: '#389e0d',
    LayoutHeaderHeight: 108,
    LayoutHeaderMiniViewHeight: 114,
    LayoutHeaderPadding: '0',
    LayoutFooterPadding: '0',
    BtnFontSizeSm: '.8rem',
    BtnTextShadow: 'none',
    DefaultBorder: '1px solid #e8e8e8',
    BorderColor: '#e8e8e8',
    HoverablesBackground: '#f0fdff'
}

const lightTheme = {
    ...commonProperties,
    PrimaryColor: '#595959', //'#26b3ea',
    PrimaryColorLight: '#bfbfbf', //'#c8ebf9',
    BackgroundColorLight: '#fff',
    LayoutBodyBackground: '#fff',
    LayoutHeaderBackground: '#fff',
    LayoutFooterBackground: '#fff',
    LayoutSiderBackground: '#fff',
    BtnDefaultBg: "#fff",
    TextColor: 'rgba(0,0,0,0.75)',
    TextHoverColor: '#000',
    DarkerBorderColor: '#d9d9d9',
    CardBackground: 'hsl(0,0%,96%)'
};

const darkTheme = {
    ...commonProperties,
    PrimaryColor: '#d9d9d9',
    PrimaryColorLight: '#f0f0f0',
    BackgroundColorLight: '#0B0D14',
    LayoutBodyBackground: '#0B0D14',
    LayoutHeaderBackground: 'black',
    LayoutFooterBackground: '#11141E',
    LayoutSiderBackground: '#0B0D14',
    BtnDefaultBg: "#11141E",
    TextColor: '#fff',
    TextHoverColor: '#fff',
    DarkerBorderColor: '#fff',
    CardBackground: '#1D222F'
};

export {
    lightTheme,
    darkTheme
};
